import * as React from 'react';

import { PaginatedArray } from 'bones/constants/voicebox/panel';
import { Button } from 'bones/design-system/components/Button';
import { LoadingIcon } from 'bones/design-system/components/icons/LoadingIcon';

export interface VoiceboxPanelLoadMoreProps<T> {
  data: PaginatedArray<T>;
  testId?: string;
}

export const VoiceboxPanelLoadMore: React.VFC<
  VoiceboxPanelLoadMoreProps<any>
> = ({ data, testId }) => {
  if (!data.hasMore) {
    return null;
  }

  return (
    <Button
      badgeProps={{
        children: Number(data.count - data.items.length).toLocaleString(),
      }}
      className="vb-data-table-more-button"
      disabled={data.loadingMore}
      onClick={() => {
        data.loadMore();
      }}
      rightIcon={data.loadingMore ? LoadingIcon : undefined}
      size="xs"
      testId={testId}
      variant="secondary-gray"
    >
      ...
    </Button>
  );
};
